import { useTranslation } from "react-i18next";
import AppContextSwitcher from "./AppContextSwitcher";
import PopupContent from "./popupContent";

interface Props {
  handleCancellation: any;
}

const AppContextSwitcherPopup = (props: Props) => {
  return (
    <PopupContent
      header="Přepnutí contextu aplikace"
      headerIconAsMdbClassName="fas fa-toggle-off"
    >
      <>
        <AppContextSwitcher />
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <button
            onClick={() => {
              props.handleCancellation();
            }}
            type="button"
            className="btn-sm btn-secondary"
          >
            Zpět
          </button>
        </div>
      </>
    </PopupContent>
  );
};

export default AppContextSwitcherPopup;
